// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:9eb6977d-76e2-45af-9c93-735f7cc9ac90",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_oDBp81Bpl",
    "aws_user_pools_web_client_id": "5ljs05e9kkp2tc5ktm5vs7p1g0",
    "oauth": {},
    "aws_appsync_graphqlEndpoint": "https://7kovabbtlzetfok7gfxkirrfvy.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS"
};
export default awsmobile;
